module.exports = __webpack_public_path__ + "assets/img/gift-7-d-af25e52f.png";